module.exports = __webpack_public_path__ + "roboto-blackitalic-webfont.f2097fbb5dccb171e659.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-blackitalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-blackitalic-webfont.woff2
// module chunks = styles